import { useComputed } from '@preact/signals';
import { currentLocale } from '../store/widget-store';
import { createI18n, detectLocale, type I18n } from '../i18n';

/**
 * Reactive i18n hook. Recomputes whenever `currentLocale` signal flips.
 *
 * Returns the full I18n object (`t`, `locale`, `dir`) so consumers can
 * spread `dir` onto the panel root for RTL support (Task 13).
 */
export function useI18n(): I18n {
  const i18n = useComputed(() => createI18n(currentLocale.value));
  return i18n.value;
}

/**
 * 启动时初始化 currentLocale signal。在 main.tsx 的 mount 之前调用,
 * 避免 ChatPanel 首次渲染时短暂用错语言再切换造成闪烁。
 */
export function initLocale(): void {
  currentLocale.value = detectLocale();
}
